export enum ApplianceTypes {
	OnlyWaterHeaterOrAirConditioner = 'Only Electric Water Heater or Air Conditioner',
	AirConditioner = 'Air Conditioner',
	ElectricHotWaterHeater = 'Electric Hot Water Heater',
	Refrigerator = 'Refrigerator',
	WellPump = 'Well Pump',
	Furnace = 'Furnace',
	ElectricRange = 'Electric Range',
	ElectricDryer = 'Electric Dryer',
}

export const InterruptibleAppliances = [ApplianceTypes.OnlyWaterHeaterOrAirConditioner];
